// Header Dropdown Menu with Flyout

; (function (jQuery) {
	"use strict";

	function Navigation_Dropdown_Flyout() {
		var global = {
			navExpanded: false
		};

		var fn = {
			init: function ()
			{
				// Desktop - Sub Menu items not-tabbable
				jQuery('header .submenu__menu-item a').attr('tabindex', '-1');

				// Desktop - Sub Menu - Show on Key Press
				jQuery('header').on('keydown', '.nav-bar__menu-item--has-children > a', function(e)
				{
					if (e.key === "ArrowDown" && jQuery(this).attr('aria-expanded') == "false")
					{
						fn.headerSubmenuOpen(e);
					}
					if (e.key === "ArrowUp" && jQuery(this).attr('aria-expanded') == "true")
					{
						fn.headerSubmenuCloseAll(e);
					}
				});

				// Desktop - Sub Menu - Hide on focus of other menu items
				jQuery(document).on('focus', '.nav-bar__menu-item > a', function(e)
				{
					fn.headerSubmenuCloseAll(e);
				});

				// Desktop - Sub Menu - Hide all on ESC
				jQuery(document).on('keyup', function(e)
				{
					if (e.key === "Escape")
					{
						fn.headerSubmenuCloseAll(e);
					}
				});

				// Mobile Menu - Hide / Show
				jQuery('header').on('click', '.nav-bar__menu-btn', fn.handleMobileMenuExpansion);

				// Mobile Menu - Sub Menu
				jQuery('header').on('click', '.submenu__show-children-toggle', fn.handleMobileSubMenuExpansion);
			},

			headerSubmenuOpen: function(e)
			{
				e.preventDefault();

				// Close all submenus
				fn.headerSubmenuCloseAll(e);

				var menuButton = jQuery(e.currentTarget);

				// Offset Position if needed - via CSS
				// fn.headerDropdownPosition(e);

				// Aria - set current dropdown as open
				menuButton.attr('aria-expanded', true);

				// Menu buttons - add active classes
				menuButton.parent().addClass('nav-bar__menu-item--active');

				// Enable sub menu items tabbable
				menuButton.parent(). find('.submenu__menu-item a').attr('tabindex', '0');

			},

			// Desktop - Sub Menu - Hide All
			headerSubmenuCloseAll: function(e)
			{
				e.preventDefault();

				// Aria - set all dropdowns as closed
				jQuery('.nav-bar__menu-item--has-children > a').attr('aria-expanded', false);

				// Menu buttons - remove active classes
				jQuery('.nav-bar__menu-item--has-children').removeClass('nav-bar__menu-item--active');

				// Disable sub menu items tabbable
				jQuery('header .submenu__menu-item a').attr('tabindex', '-1');
			},

			// Mobile Menu - Hide / Show
			handleMobileMenuExpansion: function()
			{
				var navBarMenu = jQuery('header .nav-bar__menu-container');
				var navBarButtons = jQuery('header .nav-bar__menu-btn');
				if (!global.navExpanded)
				{
					global.navExpanded = true;
					navBarMenu.addClass('nav-bar__menu-container--active');
					navBarButtons.attr('aria-expanded', 'true');
				}
				else
				{
					global.navExpanded = false;
					navBarMenu.removeClass('nav-bar__menu-container--active');
					navBarButtons.attr('aria-expanded', 'false');
				}
			},

			// Mobile Menu - Sub Menu
			handleMobileSubMenuExpansion: function(e)
			{
				if (jQuery('header .nav-bar__menu-btn').is(':visible'))
				{
					var subNavButton = jQuery(this);
					var subNavParent = subNavButton.closest('.nav-bar__menu-item');
					var subNavMenu = subNavParent.find('.nav-bar__submenu');
					subNavParent.find('.submenu__show-children-toggle').toggleClass('submenu__show-children-toggle--open');
					subNavMenu.toggleClass('nav-bar__submenu--open');
					subNavMenu.slideToggle('500');
				}
			}

		}
		jQuery(fn.init);
	}
	new Navigation_Dropdown_Flyout();
})(jQuery);